var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCopy = function SvgCopy(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 0.666672H2.66634C1.93301 0.666672 1.33301 1.26667 1.33301 2.00001V11.3333H2.66634V2.00001H10.6663V0.666672ZM12.6663 3.33334H5.33301C4.59967 3.33334 3.99967 3.93334 3.99967 4.66667V14C3.99967 14.7333 4.59967 15.3333 5.33301 15.3333H12.6663C13.3997 15.3333 13.9997 14.7333 13.9997 14V4.66667C13.9997 3.93334 13.3997 3.33334 12.6663 3.33334ZM12.6663 14H5.33301V4.66667H12.6663V14Z",
    fill: "#949494"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjY2NjMgMC42NjY2NzJIMi42NjYzNEMxLjkzMzAxIDAuNjY2NjcyIDEuMzMzMDEgMS4yNjY2NyAxLjMzMzAxIDIuMDAwMDFWMTEuMzMzM0gyLjY2NjM0VjIuMDAwMDFIMTAuNjY2M1YwLjY2NjY3MlpNMTIuNjY2MyAzLjMzMzM0SDUuMzMzMDFDNC41OTk2NyAzLjMzMzM0IDMuOTk5NjcgMy45MzMzNCAzLjk5OTY3IDQuNjY2NjdWMTRDMy45OTk2NyAxNC43MzMzIDQuNTk5NjcgMTUuMzMzMyA1LjMzMzAxIDE1LjMzMzNIMTIuNjY2M0MxMy4zOTk3IDE1LjMzMzMgMTMuOTk5NyAxNC43MzMzIDEzLjk5OTcgMTRWNC42NjY2N0MxMy45OTk3IDMuOTMzMzQgMTMuMzk5NyAzLjMzMzM0IDEyLjY2NjMgMy4zMzMzNFpNMTIuNjY2MyAxNEg1LjMzMzAxVjQuNjY2NjdIMTIuNjY2M1YxNFoiIGZpbGw9IiM5NDk0OTQiLz4KPC9zdmc+Cg==";